import axios from "axios";
import { useState, useRef, useEffect } from "react";

import Input from '@/components/Input';
import Button from '@/components/Button';
import { getErrorMessage } from '@/utils/Errors';

export default function SearchUser({t,language,user,apiUrl,token,sendMessage,setRootAnswer,handleLogin,confirmDelete}){

    const divRef = useRef(null); 

    useEffect(() => {
        // scroll to div
        if(divRef.current) {
            divRef.current.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
        
    }, []);

    const [ data, setData ] = useState({
        name: '',
        email: ''
    });

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    const handleSubmit = () => {
        
        var errors = false;

        if(data.email.length === 0 && data.name.length === 0){
            errors = true;
            sendMessage(t('error.empty'));
        }
        
        if(!errors){
            
            const apiPath = '/users/filter';

            const config = {
                headers: { Authorization: `Bearer ${token}` },   
                // params is the same as using ?database=, query params      
                params: {
                    language: language,
                    companyuser: user?.company,
                    filters: data
                }  
            };
            
            const url = apiUrl+apiPath;

            var errorMessage = t('root.search_user.notfound');
            
            axios.get(url,config)
            .then(function (response) {

                if(response?.data){
              
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){

                        sendMessage(t('root.search_user.found'));
                        
                        const data = responseData?.data;

                        const render = 
                            <div className='mt-4'>                                       
                                <div className="text-xl font-bold mb-2">
                                    {t('root.search_user.found')+' ('+data?.items?.length+')'}
                                </div>                        
                                <div className="">
                                    {
                                        data?.items && data.items?.map((item,index) => (                                            
                                            <div 
                                                key={'root-action-search-users-item-'+index}
                                                className='border rounded bg-red-100 mb-2 p-2'
                                            >
                                                {
                                                    Object.keys(item)?.map((key) => (                                            
                                                        <div key={'root-action-search-users-item-'+index+'-key-'+key}>
                                                            <b>{key}</b>: {
                                                                item[key] !== null && typeof item[key] === 'object' ?
                                                                    Object.keys(item[key])?.map(subkey => item[key][subkey]['name']).join(' / ')
                                                                :
                                                                    item[key]
                                                            }
                                                        </div>
                                                    ))
                                                }
                                                <div className='mt-2 text-center'>
                                                    <Button
                                                        type='delete'
                                                        variant='contained'
                                                        text={t('actions.delete.button')}
                                                        onClick={() => confirmDelete(item['id'])}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ;
                        setRootAnswer(render);
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            // check error message
                            if(responseData?.data?.reasons){      
                                errorMessage = getErrorMessage(t,'root.search_user',responseData?.data?.reasons);
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
    }

    // submit with enter
    const handleKeyDown = () => {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    }

	return (        
        <div className='mt-4' ref={divRef}>
            <div className='mb-4'>
                {t('root.search_user.description')}
            </div>
            <div className='mb-4'>
                <Input                      
                    name="name"
                    type="text"
                    value={data.name}                      
                    placeholder={t('root.search_user.fields.name')}                    
                    onChange={handleInput}
                    handleKeyDown={handleKeyDown}
                    //error={}                    
                />
            </div>
            <div className='mb-4'>
                <Input                      
                    name="email"
                    type="email"
                    value={data.email}                      
                    placeholder={t('root.search_user.fields.email')}                    
                    onChange={handleInput}
                    handleKeyDown={handleKeyDown}
                    //error={}
                />
            </div>            
            <div className='text-center'>
                <Button                     
                    onClick={handleSubmit}
                    text={t('root.search_user.button')}
                    type='accept'            
                />
            </div>
        </div>
    );
}